import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Strong, Em, Span, List } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"en/instrukciya"} />
		<Helmet>
			<title>
				How to Create an Online Store in the Form of a Web Bot in Telegram | uShopWebBot
			</title>
			<meta name={"description"} content={"Пошаговая инструкция по созданию интернет-магазина в Телеграм в конструкторе"} />
			<meta property={"og:title"} content={"How to Create an Online Store in the Form of a Web Bot in Telegram | uShopWebBot"} />
			<meta property={"og:description"} content={"Step-by-Step Guide to Creating an Online Store in Telegram Using a Builder"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Creating an Online Store
							</Link>
							<Link
								href="/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Connecting the Bot
							</Link>
							<Link
								href="/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Online Payment
							</Link>
							<Link
								href="/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Instructions
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Create Web Bot
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Components.EnButtonBot />
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section
			padding="180px 0 180px 0"
			background="linear-gradient(0deg,rgba(2, 2, 2, 0.18) 0%,rgba(2, 2, 2, 0.18) 99.5%),rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/background1111.png?v=2022-08-25T10:45:21.612Z) center center/100% repeat scroll padding-box"
			sm-padding="50px 0 50px 0"
			lg-background="rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/62ab65c921e43d0020961286/images/background1111.png?v=2022-08-25T10:45:21.612Z) center center/cover repeat scroll padding-box"
			md-padding="90px 0 90px 0"
		>
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Step-by-Step Guide to Creating a Telegram Store
			</Text>
			<Text
				margin="8px 0px 0px 0px"
				font="--headline3"
				color="--white"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
			>
				Creating an online store in the form of a web bot in four simple steps.
				<br />
				The bot itself is created without code in about 15 minutes.
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			<Text
				margin="0px 0px 8px 0px"
				font="--headline3"
				color="--dark"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
				md-display="none"
			>
				Step-by-step video guide for creating a store in Telegram, choose your device:
			</Text>
			<Text
				margin="0px 0px 8px 0px"
				font="--headline3"
				color="--dark"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
				display="none"
				md-display="flex"
			>
				Step-by-step video guide for creating a store in Telegram:
			</Text>
			<Components.Tabs2 defaultTab="one">
				<Override slot="Tab one">
					💻 PC
				</Override>
				<Override slot="Tab two">
					📱 Phone
				</Override>
				<Override
					slot="Tab"
					border-radius="0px"
					width="100%"
					hover-opacity="1"
					color="--dark"
					focus-box-shadow="none"
					border-width="3px"
					border-style="solid"
					border-color="--color-primary"
					background="--background"
					font="--button"
				/>
				<Override slot="TabPanels" border-width="5px" border-style="solid" border-color="--color-primary" />
				<Override
					slot="Tab :active"
					border-radius="0px"
					border-color="--color-primary"
					border-width="3px"
					border-style="solid"
					background="--primary"
					color="--white"
				/>
				<Override slot="Tablist" md-display="none" />
				<Components.Tab2
					tabId="one"
					border-color="#0E86F8"
					border-width="2px"
					border-style="solid"
					md-display="none"
				>
					<Components.QuarklycommunityKitYouTube margin="0px 0px 0px 0px" url="https://www.youtube.com/watch?v=DejTcbdSEe0?showinfo=0&enablejsapi=1&origin=https://ucoz.ru/" />
				</Components.Tab2>
				<Components.Tab2 tabId="two" border-width="2px" md-display="block">
					<Components.QuarklycommunityKitYouTube margin="0px 0px 0px 0px" url="https://www.youtube.com/watch?v=XWTXmlfZZC0?showinfo=0&enablejsapi=1&origin=https://ucoz.ru/" />
				</Components.Tab2>
			</Components.Tabs2>
			<Text
				margin="8px 0px 0px 0px"
				font="--headline3"
				color="--dark"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
			>
				If you have any questions while creating the bot, you can contact support:{" "}
				<Link
					href="https://t.me/uShopHelpBot"
					border-color="--color-primary"
					text-decoration-line="initial"
					target="_blank"
					hover-opacity="0.7"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					@uShopHelpBot
				</Link>
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			{"    "}
			<Text
				margin="0px 0px 40px 0px"
				font="--headline3"
				color="--darkL1"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
			>
				{"        "}For those who do not want to watch the video or do not have the opportunity, we will describe the steps in text format.{"\n    "}
			</Text>
			{"    "}
			<Text
				id="shop"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--darkL1"
			>
				{"        "}1. Creating an Online Store{"\n    "}
			</Text>
			{"    "}
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--darkL1">
				{"        "}The entire instruction may seem lengthy, but in fact, creating a bot is just the regular process of registering an account, a website, and a bot, followed by setting up the bot (avatar, adding products, etc.). But the most important thing is that the bot is created{" \n        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}completely without code{"\n        "}
				</Strong>
				{"        "}, meaning no programming skills are required.{" \n        "}
				<br />
				{"        "}Let's get started on creating our bot:{" \n        "}
				<br />
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}1.1.{"\n        "}
				</Strong>
				{"         "}Launch our bot constructor:{" \n        "}
				<Link
					href="https://t.me/uShopWebBot"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					hover-opacity="0.7"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					{"            "}@uShopWebBot{"\n        "}
				</Link>
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}1.2.{"\n        "}
				</Strong>
				{"         "}In the first message from the bot, click the button "{"\n        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}🛒 Create a Store{"\n        "}
				</Strong>
				{"        "}"{"\n        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}1.3.{" \n        "}
				</Strong>
				{"        "}Next, a window will open with links to this instruction and a link to technical support; we will click the button "{"\n        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}🤖 Create a Web Bot{"\n        "}
				</Strong>
				{"        "}"{"\n        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}1.4.{" \n        "}
				</Strong>
				{"        "}In the next message, click the button "🔑{" \n        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}Register{"\n        "}
				</Strong>
				{"        "}", after clicking, the registration phase will begin, and you will need to send your email, create a password, and then confirm your email. In the last stage of registration, you will need to come up with a technical address for your future website.{"\n    "}
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			{"    "}
			<Text id="bot" margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif">
				{"        "}2. Instructions for Connecting the Bot{"\n    "}
			</Text>
			{"    "}
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				{"        "}As soon as we create the website, we need to create the bot itself{"\n        "}
				<br />
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.1.{"\n        "}
				</Strong>
				{"        "}After logging into your account, you need to enter the command /newbot{"\n        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.2{"\n        "}
				</Strong>
				{"        "}Next, a list of all your sites will appear. If you have created only one site, it will be the only one shown, so select it.{"\n        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.3.{" \n        "}
				</Strong>
				{"        "}After selecting the site, we need to connect the Telegram bot.{"\n        "}
				<br />
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}The bot itself is created in the official Telegram bot{" \n            "}
					<Link
						href="https://t.me/BotFather"
						target="_blank"
						text-decoration-line="initial"
						color="--primary"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						hover-text-decoration-line="underline"
					>
						{"                "}Botfather{"\n            "}
					</Link>
					{"            "}:{"\n            "}
					<br />
					{"        "}
				</Strong>
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.4.{" \n        "}
				</Strong>
				{"        "}Go to the bot:{" \n        "}
				<Link
					href="https://t.me/BotFather"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}@Botfather{"\n        "}
				</Link>
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.5.{" \n        "}
				</Strong>
				{"        "}Start it and enter the command /newbot{"\n        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.6.{" \n        "}
				</Strong>
				{"        "}Come up with a name for your bot (For example: "{"\n        "}
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}On the Couch - Furniture Store{"\n        "}
				</Em>
				{"        "}"){"\n        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.7.{" \n        "}
				</Strong>
				{"        "}Come up with a @username for the bot (It must end with bot, example:{" \n        "}
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}@uShopTelegramBot{"\n        "}
				</Em>
				{"        "}){"\n        "}
				<br />
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}2.8.{" \n        "}
				</Strong>
				{"        "}After that, you will receive the token for your bot, which you need to send to the constructor{" \n        "}
				<Link
					href="https://t.me/uShopWebBot"
					color="--primary"
					text-decoration-line="initial"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}@uShopWebBot{"\n        "}
				</Link>
				{"        "}:{"\n    "}
			</Text>
			{"    "}
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					{"            "}Screenshot{"\n        "}
				</Override>
				{"                "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15:05:27.580Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tokenbot.png?v=2022-07-24T15%3A05%3A27.580Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"    "}
			</Components.QuarklycommunityKitCollapse>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			{"    "}
			<Text margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif" as="h2">
				{"        "}3. Bot Design{"\n    "}
			</Text>
			{"    "}
			<Text margin="0px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				{"        "}Hooray 🥳! We have created a bot. But this is only half the journey. Now we need to design it and fill it with products.{"\n        "}
				<br />
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}3.1.{"\n        "}
				</Strong>
				{"        "}Everything related to the bot's design (avatar, bot description), that is, all the information displayed before the bot starts, can be fully configured in @Botfather. You will need to enter the command /mybots, then select your bot and go to the "Edit Bot" section. There, you can set the bot's: Name, About, Pic, Description (which is visible before starting), and an image for this description.{"\n        "}
				<br />
				{"        "}
				<br />
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}3.2.{"\n        "}
				</Strong>
				{"        "}The information displayed within the bot (welcome text, names and text of buttons, bot color and design, etc.) is configured in the /admin section (this{" \n        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}
					<Span
						color="--red"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						{"                "}command is written in your bot store{"\n            "}
					</Span>
					{"        "}
				</Strong>
				{"        "}that you created) and in this section, you need to select the "Change Design" option and go to the "Buttons and Links" tab.{"\n    "}
			</Text>
			{"    "}
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					{"            "}Screenshots{"\n        "}
				</Override>
				{"                "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14:26:22.919Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/smenadesing.png?v=2024-11-01T14%3A26%3A22.919Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"        "}
				<Text margin="8px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
					{"            "}After which you will enter your bot's control panel, and there you need to specify your texts - contacts, information about the store, welcome text, and more:{"\n        "}
				</Text>
				{"        "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15:14:17.253Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/knopkissilka.png?v=2024-11-01T15%3A14%3A17.253Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"    "}
			</Components.QuarklycommunityKitCollapse>
			{"    "}
			<Text
				margin="20px 0px 0px 0px"
				font="--headline3"
				color="--darkL1"
				md-text-align="center"
				sm-font="normal 500 16px/24px &quot;Montserrat&quot;, sans-serif"
				sm-color="--dark"
			>
				{"        "}In the "Change Design" section, you can also change the design/template of your bot store,{" \n        "}
				<Link
					href="https://www.youtube.com/watch?v=Nmrs5L53UVw"
					color="--primary"
					target="_blank"
					text-decoration-line="initial"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
					hover-target="_blank"
				>
					{"            "}video tutorial{"\n        "}
				</Link>
				{"    "}
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			{"    "}
			<Text margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif" as="h2">
				{"        "}4. Adding a Product{"\n    "}
			</Text>
			{"    "}
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				{"        "}
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}Now we need to decide how we will add the product, specifically whether it will be manual entry or importing the product from some source (from your old site, Moy Sklad, 1C, Yandex.Market, or simply from an Excel price list){"\n            "}
					<br />
					{"            "}
					<br />
					{"            "}
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						{"                "}4.1.{" \n            "}
					</Strong>
					{"        "}
				</Span>
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}Adding a Product Manually:{"\n            "}
					<br />
					{"        "}
				</Strong>
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}4.1.1. Product Categories.{"\n        "}
				</Strong>
				{"        "}Go to your created bot store and enter the command /admin, then select the "Manage Categories" section where you can delete the default categories and create your own.{"\n    "}
			</Text>
			{"    "}
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					{"            "}Screenshot{"\n        "}
				</Override>
				{"                "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16:43:40.829Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kategoriitovara.png?v=2024-11-01T16%3A43%3A40.829Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"    "}
			</Components.QuarklycommunityKitCollapse>
			{"    "}
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}4.1.2 Variations/Options of the Product.{"\n        "}
				</Strong>
				{"         \n        "}
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}(this item is optional){"\n        "}
				</Em>
				{"        "}
				<br />
				{"        "}If you need the option to select characteristics when placing an order for the product, such as choosing color, size, flavor, etc., you can create product options. Example options in the bot store:{" \n        "}
				<Link
					href="https://t.me/SportClothesBot/menu?startapp=product_220"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					{"            "}Size and Color Selection for Clothing{"\n        "}
				</Link>
				{"        "},{" \n        "}
				<Link
					href="https://t.me/Dolce_Bot/menu?startapp=product_15"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					{"            "}Set and Quantity Selection for Delivery{"\n        "}
				</Link>
				{"    "}
			</Text>
			{"    "}
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					{"            "}Screenshot{"\n        "}
				</Override>
				{"                "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16:52:02.212Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/opciitovara.png?v=2024-11-01T16%3A52%3A02.212Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"    "}
			</Components.QuarklycommunityKitCollapse>
			{"    "}
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}4.1.3 Placing the Product.{" \n        "}
				</Strong>
				{"        "}
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}Now we come to the main part. Adding a product happens directly in your bot store; you also need to enter the command /admin and select the "📥 Add Product" option.{"\n        "}
				</Span>
				{"    "}
			</Text>
			{"    "}
			<Components.QuarklycommunityKitCollapse margin="4px 0px 24px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					{"            "}Screenshots{"\n        "}
				</Override>
				{"                "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17:16:34.620Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/dodavittovatr.png?v=2024-11-01T17%3A16%3A34.620Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"        "}
				<Text margin="8px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
					{"            "}If you are selling services or digital products (files, keys, links, codes, etc.), you need to change the product type.{" \n            "}
					<Link
						href="/prodazha-elektronnykh-tovarov-v-telegram"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						{"                "}Detailed instructions{"\n            "}
					</Link>
					{"        "}
				</Text>
				{"        "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17:23:37.445Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/tiptovara.png?v=2024-11-01T17%3A23%3A37.445Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"    "}
			</Components.QuarklycommunityKitCollapse>
			{"    "}
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				{"        "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"            "}4.2. Bulk Import of Products:{"\n            "}
					<br />
					{"        "}
				</Strong>
				{"        "}If manual entry does not suit you, we have the option to import products from Excel (XLS/XLSX/CSV/Google Docs) and 1C, YML (Yandex.Market), Moy Sklad, etc.{"\n        "}
				<br />
				{"        "}When importing products, you do not need to create options and categories manually; you only need to specify a single column that contains the name of the category, and all your products will be sorted into it.{"\n        "}
				<br />
				{"        "}
				<Link
					href="https://t.me/SportClothesBot/menu?startapp=product_220"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					{"            "}Example Import for Clothing{"\n        "}
				</Link>
				{"        "},{" \n        "}
				<Link
					href="https://t.me/Dolce_Bot/menu?startapp=product_15"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					hover-text-decoration-line="underline"
				>
					{"            "}Example Import for Delivery{"\n        "}
				</Link>
				{"    "}
			</Text>
			{"    "}
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					{"            "}Screenshot{"\n        "}
				</Override>
				{"                "}
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17:41:43.604Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/importtovara.png?v=2024-11-01T17%3A41%3A43.604Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
				{"    "}
			</Components.QuarklycommunityKitCollapse>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0" background="--background">
			<Text
				id="pay"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				5. Currency Settings and Stock Management
			</Text>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						5.1. Currency Setup.{" "}
					</Strong>
					You can accept payments for your products in any currency: Rubles, Hryvnias, Tenge, Soums, Dollars, Euros, Pounds, and in 77 other currencies. 
You can also accept payments in cryptocurrencies (USDT, BTC, ETH, TON, etc.)
				</Span>
				<br />
				You can edit the currency in the section /admin - the "Control Panel" item, and then select the "Payment and Delivery" section:
				<Link
					href="https://t.me/Dolce_Bot/menu?startapp=product_15"
					text-decoration-line="initial"
					target="_blank"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				/>
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 16px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Screenshot
				</Override>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18:24:58.004Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/valutared.png?v=2024-11-01T18%3A24%3A58.004Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
			<Text margin="0px 0px 4px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					5.2. Stock Management.
				</Strong>
				{" "}
				<Em
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					(This item is not mandatory)
				</Em>
				<br />
				All physical products in the online store have a field that indicates availability or delivery date. With the stock management function, you can:
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="disc"
				as="ul"
				font="--base"
			>
				<Text margin="0px 0px 0px 0px">
					Automatically deduct purchased items
				</Text>
				<Text margin="0px 0px 0px 0px">
					Prevent adding items to the cart with zero stock
				</Text>
				<Text margin="0px 0px 0px 0px">
					Automatically hide items that are out of stock
				</Text>
				<Text margin="0px 0px 0px 0px">
					Import stock from XLS and 1C price lists
				</Text>
			</List>
			<Text margin="6px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong>
					<Link
						href="https://www.ucoz.ru/help/online-shop/uchet-ostatkov"
						target="_blank"
						color="--primary"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						<Span
							font-weight="normal"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Instructions for Managing Stock
						</Span>
					</Link>
				</Strong>
			</Text>
		</Section>
		<Section padding="40px 0 40px 0" sm-padding="20px 0 20px 0" md-padding="60px 0 20px 0">
			<Text
				id="pay"
				margin="0px 0px 24px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				6. Connecting Online Payments
				<br />
			</Text>
			<Text margin="0px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" overflow-wrap="break-word">
				{"    "}In the bot, you can connect payment services that allow you to accept payments in rubles, hryvnias, tenge, som, dollars, euros, pounds, and 77 other currencies without leaving the chat with the bot.{"\n    "}
				<br />
				{"    "}
				<br />
				{"    "}
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"        "}6.1. Connecting payments from uCoz:{"\n    "}
				</Strong>
				{"    "}
				<br />
				{"    "}We have internal direct integrations with payment systems:{" \n    "}
				<br />
				{"    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/yookassa"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}YooKassa{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/yoomoney-dlya-fiz-lic"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}YooMoney for Individuals{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/sberbank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}Sberbank{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/liqpay"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}LiqPay{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/wallet-one"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}Wallet One{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/robokassa"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}ROBOKASSA{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/fondy"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}Fondy{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/paypal"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}PayPal{"\n    "}
				</Link>
				{"    "},{"\n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/webmoney"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}WebMoney{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/freekassa"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}Freekassa{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/unitpay"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}UnitPay{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/cloudpayments"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}CloudPayments{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/stripe"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}Stripe{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/tinkoff"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}T-Bank{"\n    "}
				</Link>
				{"    "},{"\n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/sberbank-credit"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}Sberbank Credit{"\n    "}
				</Link>
				{"    "},{" \n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/payments/enotio"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					text-decoration-line="initial"
					color="--primary"
					hover-text-decoration-line="underline"
				>
					{"        "}enot.io{"\n    "}
				</Link>
				{"    "}, Wata,{" \n    "}
				<Link
					href="https://www.ucoz.ru/bot/onlayn-oplata-v-telegram-magazine/"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"        "}Crypto{"\n    "}
				</Link>
				{"    "}.{"\n    "}
				<br />
				{"    "}
				<br />
				{"    "}To learn how to connect payments from uCoz, follow the link:{"\n    "}
				<Link
					href="https://www.ucoz.ru/help/online-shop/integration/"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{"        "}How to connect payments{"\n    "}
				</Link>
			</Text>
			<Text margin="0px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					6.2. Connecting Telegram Payments:
				</Strong>
				<br />
				For Telegram, the following payment systems are integrated by default: YuKassa, Tranzzo (Interkassa), Stripe, UnitPay, PaycomUZ / Payme, CLICK Uzbekistan, Rave by Flutterwave, LiqPay, Smart Glocal, Unlimint, Paykassma, PSB, Bank 131, LeoGaming, Cascad, Paymega, Portmone, Global Pay UZ, iPay88, ECOMMPAY, and PayMaster.
				<br />
				<br />
				To connect these payments from Telegram, you need to go to the "🛠
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					{" "}Bot Settings
				</Strong>
				" (/mybot) in the bot{" "}
				<Link
					href="https://t.me/uShopWebBot"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@uShopWebBot{" "}
				</Link>
				<br />
				And then select the "💰 Payment" section, after which you will need to send the payment name and the payment system token.
				<br />
				<br />
				You can obtain the payment system token from{" "}
				<Link
					href="https://t.me/BotFather"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@Botfather
				</Link>
				; for this, you will need to go to your bot's settings and select the "
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Payments
				</Strong>
				" section.
			</Text>
			<Components.QuarklycommunityKitCollapse margin="4px 0px 0px 0px" padding="2px 2px 2px 2px" height="auto">
				<Override slot="Button" width="100%" text-align="left" font="--menu">
					Screenshots
				</Override>
				<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21:14:37.737Z" display="block" srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/payments.png?v=2022-08-26T21%3A14%3A37.737Z&quality=85&w=3200 3200w" sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw" />
				<Text margin="8px 0px 16px 0px" font="--base" sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif">
					After that, you need to select the payment system you want to connect for receiving payments and activate it.
				</Text>
				<Image
					src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14:38:33.772Z"
					display="block"
					width="100%"
					srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/paybotfather.png?v=2024-11-04T14%3A38%3A33.772Z&quality=85&w=3200 3200w"
					sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
				/>
			</Components.QuarklycommunityKitCollapse>
		</Section>
		<Section
			padding="40px 0 40px 0"
			sm-padding="20px 0 20px 0"
			md-padding="60px 0 20px 0"
			background="--background"
			display="none"
		>
			<Text margin="0px 0px 24px 0px" font="--headline2" sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif" as="h2">
				7. Интеграция служб доставки
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				Если продаете товар/продукт с доставкой, то вы можете интегрировать службы доставки, чтобы они предоставили список своих ПВЗ и делали расчет доставки исходя из расстояния, веса и габбаритов вашей посылки.
				<br />
				<br />
				Инструкции:
			</Text>
			<List
				margin="0px 0px 0px 0px"
				padding="0px 0px 0px 20px"
				list-style-type="disc"
				as="ul"
				font="--base"
			>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/sdek"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Интеграция службы доставки СДЭК
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/pochta_ru"
						color="--primary"
						target="_blank"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Подключение Почты России
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/novaposhta"
						color="--primary"
						target="_blank"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Почтовая служба Нова Пошта
					</Link>
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/apiship"
						color="--primary"
						target="_blank"
						text-decoration-line="initial"
						hover-text-decoration-line="underline"
					>
						Интегратор служб доставки ApiShip
					</Link>
					, с его помощью можно подключить такие сервисы как: Яндекс.Доставка, Сберлогистик, Достависта, Деловые Линии, Boxberry и прочие
				</Text>
				<Text margin="0px 0px 0px 0px">
					<Link
						href="https://www.ucoz.ru/help/online-shop/dostavka/matrica-formirovaniya-cen"
						color="--primary"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
					>
						Матрица формирования цен на доставку
					</Link>
					{" "}без служб доставки
				</Text>
			</List>
		</Section>
		<Section
			id="faq"
			padding="60px 0 90px 0"
			background="--white"
			position="relative"
			md-padding="60px 0 60px 0"
			sm-padding="30px 0 60px 0"
		>
			<Override
				slot="SectionContent"
				width="90%"
				max-width="none"
				align-items="center"
				padding="60px 30px 60px 30px"
				background="--background"
				border-radius="32px"
				md-padding="40px 20px 40px 20px"
				sm-width="95%"
			/>
			<Box max-width="1280px" width="100%">
				<Text
					margin="0px 0px 36px 0px"
					color="--darkL1"
					font="--headline1"
					md-text-align="center"
					sm-font="normal 800 30px/1.4 &quot;Montserrat&quot;, sans-serif"
					lg-text-align="center"
					lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				>
					FAQ - Frequently Asked Questions
				</Text>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						How does our service differ from other services?
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						/>
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						We are the first web bot builder focused on E-commerce; you can create a Telegram store in just 10 minutes. We don't have unnecessary features, and the interface is intuitive for everyone. Just create a bot in Botfather, connect it to our builder, upload your products, and start selling on Telegram.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						What other capabilities does the bot have besides sales on Telegram?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						Aside from selling products and accepting online payments, the bot can do the following:
					</Text>
					<List
						margin="0px 0px 0px 0px"
						padding="0px 0px 0px 20px"
						list-style-type="disc"
						as="ul"
						font="--base"
					>
						<Text margin="0px 0px 0px 0px">
							Send broadcasts to all users who have launched your bot, for example, you can notify them about discounts or promotions on products;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Create promo codes;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Add an extra button in the bot's menu to include your contact details;
						</Text>
						<Text margin="0px 0px 0px 0px">
							View statistics for your bot;
						</Text>
						<Text margin="0px 0px 0px 0px">
							Get notifications about new orders directly in the bot;
						</Text>
						<Text margin="0px 0px 0px 0px">
							And in addition to the bot, you create a full-fledged online store with all the necessary functionality, which is included in one tariff.
						</Text>
					</List>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						Which payment systems and currencies are available in the bot?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						The bot can connect payment services that allow accepting payments in{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Rubles
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Hryvnias
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Tenge
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Soms
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Dollars
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Euros
						</Em>
						,{" "}
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Pounds
						</Em>
						, and in other 77 currencies while staying in dialogue with the bot.
						<br />
						<br />
						Payment systems available within Telegram:{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Robokassa
						</Strong>
						,{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Payme
						</Strong>
						,{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Click
						</Strong>
						,{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							PayPal
						</Strong>
						, and many more.
					</Text>
				</Components.QuarklycommunityKitCollapse>
				<Components.QuarklycommunityKitCollapse
					width="100%"
					padding="0px 0px 8px 0px"
					border-width="0px"
					border-style="none"
					sm-margin="0px 0px 6px 0px"
					sm-text-align="center"
				>
					<Override
						slot="Button"
						font="--headline2"
						background="none"
						color="--dark"
						padding="8px 24px 8px 0px"
						sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
						lg-width="100%"
						lg-text-align="center"
						lg-padding="8px 0px 8px 0px"
						transition="opacity 0.2s ease-in-out 0s"
						hover-opacity="0.6"
					>
						How can I start creating my bot?
					</Override>
					<Text margin="0px 0px 0px 0px" font="--base">
						To start using our service, you need to register and get access to the bot builder. After that, create a bot in Botfather and connect it to our service. The bot will be automatically created based on your template.
					</Text>
				</Components.QuarklycommunityKitCollapse>
			</Box>
		</Section>
		<Structure
			id="webbot"
			padding="80px 0px 80px 0px"
			cells-number-total="10"
			quarkly-title="Content"
			nout-padding="60px 0px 60px 0px"
			position="relative"
			sm-padding="30px 0px 60px 0px"
			background="--primary"
		>
			<Override
				slot="Content"
				grid-template-columns="repeat(3, 1fr)"
				grid-gap="24px"
				nout-grid-template-columns="1fr"
				sm-overflow-x="hidden"
				sm-overflow-y="hidden"
			>
				<Override slot="Cell 0th" />
				<Override slot="Cell 0" grid-column="1 /span 3" nout-grid-column="auto / auto" />
				<Override slot="cell-0">
					<Text
						margin="0px 0px 10px 0px"
						color="--white"
						font="--headline1"
						lg-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
						md-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
						sm-text-align="center"
						md-text-align="center"
					>
						Полезные статьи
					</Text>
				</Override>
				<Override slot="cell-1">
					<Box
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						min-height="540px"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Продвижение интернет-магазина
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Статья о том как правильно и какими способами продвигать магазин в формате Телеграм-бота
								</Text>
							</Box>
						</Box>
						<Link
							href="/prodvizhenie-internet-magazina-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-2">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1521931961826-fe48677230a5?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Нужен ли магазин в Телеграм?
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Давайте разберемся, а стоит ли создавать магазин в Телеграм и заниматься его продвижением
								</Text>
							</Box>
						</Box>
						<Link
							href="/dlya-chego-sozdat-magazin-v-telegram/"
							color="--white"
							text-align="center"
							padding="18px 16px 18px 16px"
							text-decoration-line="initial"
							background="--dark"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-3">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22:40:45.741Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/kanaltg.jpg?v=2023-01-18T22%3A40%3A45.741Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Интеграция Телеграм канала и чата с ботом
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Инструкции по размещению товара в каналах, личных чатах и группах.{" "}
								</Text>
							</Box>
						</Box>
						<Link
							href="/onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="Cell 3" sm-display="flex" sm-align-items="center" sm-justify-content="center" />
				<Override slot="cell-4">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=700"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1649424221028-8e7d31f2e3c9?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Продажа электронных товаров в боте
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									В Телеграм боте в который вы создадите возможно продавать не только физические товары, но и цифровые (файлы, коды, курсы и пр.)
								</Text>
							</Box>
						</Box>
						<Link
							href="/prodazha-elektronnykh-tovarov-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-5">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=700"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1522096823084-2d1aa8411c13?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Рассылка для ваших клиентов бота
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Запускаем рассылку среди всех пользователей которые запустили ваш бот-магазин
								</Text>
							</Box>
						</Box>
						<Link
							href="/sozdaniye-rassylki-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-6">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=600"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=500 500w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800 800w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080 1080w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1600 1600w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000 2000w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2600 2600w,https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Уведомления о новых заказах в Телеграм
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Получаем уведомления в Телеграм о заказах с интернет-магазина{" "}
								</Text>
							</Box>
						</Box>
						<Link
							href="/uvedomleniya-o-zakazakh-v-magazine-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-7">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Перенос бота клиенту или передача прав
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Как полностью сменить владельца у бота или сделать частичную передачу прав на управление бота
								</Text>
							</Box>
						</Box>
						<Link
							href="/prava-na-bot-magazin/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-8">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=500 500w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=800 800w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1080 1080w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600 1600w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000 2000w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2600 2600w,https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Конструктор верхней части бота
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Генератор HTML-кода для облегченного управление верхней частью сайта
									<br />
								</Text>
							</Box>
						</Box>
						<Link
							href="/create-logo/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
				<Override slot="cell-9">
					<Box
						min-height="540px"
						background="--white"
						border-radius="32px"
						padding="0px 0px 0px 0px"
						overflow-x="hidden"
						overflow-y="hidden"
						display="flex"
						flex-direction="column"
						justify-content="space-between"
						transition="--transformOut"
						hover-transform="translateY(-5px)"
					>
						<Box min-width="100px" min-height="100px">
							<Image
								src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12:33:16.321Z"
								display="block"
								width="100%"
								max-height="223px"
								margin="0px 0px 14px 0px"
								object-fit="cover"
								srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/desingcode.png?v=2024-04-05T12%3A33%3A16.321Z&quality=85&w=3200 3200w"
								sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
							/>
							<Box>
								<Text
									color="--dark"
									font="--headline2"
									margin="0px 20px 16px 20px"
									md-text-align="center"
									as="h3"
								>
									Дизайн вашего каталога в Телеграм
								</Text>
								<Text color="--dark" font="--base" margin="0px 20px 40px 20px" md-text-align="center">
									Как правильно редактировать и красиво оформить каталог вашего бота. Правильная работа с кодом (CSS, JS, HTML)
								</Text>
							</Box>
						</Box>
						<Link
							href="/oformlenie-magazina-v-telegram/"
							color="--white"
							padding="18px 16px 18px 16px"
							text-align="center"
							background="--dark"
							text-decoration-line="initial"
							font="normal 600 16px/1.5 --fontFamily-googleMontserrat"
							transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
							hover-color="--primary"
							hover-background="--white"
							target="_blank"
						>
							Читать далее
						</Link>
					</Box>
				</Override>
			</Override>
		</Structure>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
			>
				Let our professionals create a full-fledged online store and Telegram bot from $190
				<br />
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Our experts create custom sites, online stores, portals, and landing pages. Help, consultations, and SEP promotion are also available.
			</Text>
			<Link
				href="https://divly.net/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Order a turnkey Telegram bot
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.com/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Legal information
				</Link>
				<Link
					href="https://www.ucoz.com/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Terms of use
				</Link>
			</Box>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});